import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import fileIcon from '../../images/newDesign/file.svg';
import { FileSize } from '../../ui/FileSize';
import { UploadListItemStyled } from '../archivePage/UploadListItem.styled';

const UploadListItem = ({ item }) => {
    const { t } = useTranslation();
    const [lastUpdate, setLastUpdate] = useState(Date.now());

    useEffect(() => {
        item.addEventListener('change', handleItemChange);
        return () => item.removeEventListener('change', handleItemChange);
    }, [item]);

    const loading = item.loaded != null;

    function handleItemChange(e) {
        setLastUpdate(Date.now());
    }

    return (
        <UploadListItemStyled className='list-item'>
            <img src={fileIcon} />
            <div className='progress-line'>
                <div className='progress-head'>
                    <div className='file-name'>{item.name}</div>
                    <div><FileSize>{item.size}</FileSize></div>
                </div>
                <progress max={item.size} value={item.loaded}></progress>
                <div className={classNames({ 'no-progress': !loading })}>
                    <span>{Math.round( 100 * item.loaded / item.size)}%</span> <span>{t('archive.upload_per_cent_done')}</span>
                </div>
            </div>
        </UploadListItemStyled>
    )
}

export default UploadListItem;